/* eslint-disable no-restricted-imports */
import * as React from 'react';
import { IconButton, Typography } from 'bento';
import { IconCrossLarge } from '@tock/icons';
import {
  DialogTitle as MuiDialogTitle,
  DialogTitleProps as MuiDialogTitleProps,
} from '@material-ui/core';
import { dialogTitleButton, dialogTitleStyles, dialogTitleText } from './dialogTitleCssDefs';

interface DialogTitleWrapperProps {
  id: string;
  onClose?(event: React.MouseEvent<HTMLButtonElement>): void;
}

export type DialogTitleProps = MuiDialogTitleProps & DialogTitleWrapperProps;

/**
 * @deprecated Deprecated — use pantry Modal.Header instead.
 * @see https://docs.tocktix.com/pantry?path=/docs/components-modal-modal-header--docs
 */
export const DialogTitle = ({ children, onClose, id, ...rest }: DialogTitleProps) => {
  return (
    <MuiDialogTitle disableTypography css={dialogTitleStyles} {...rest}>
      <Typography css={dialogTitleText} id={id} variant="heading03" color="default">
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          size="medium"
          color="subtle"
          css={dialogTitleButton}
          onClick={onClose}
        >
          <IconCrossLarge />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};
